<template>
	<div class="index_content">
		<div class="complet_title">
			<div class="tips">
				<div class="tit_a">恭喜完成测试</div>
				<div class="tit_b">点击下方按钮下载报告</div>
			</div>
		</div>
		<div class="complet_con">
			<div class="complet_con_tit">测试得分</div>
			<div class="complet_con_circle">
				<img src="../../assets/imgs/bg_p07@2x.png" />
				<div class="num"><span>{{scoreData.scorenum || '0'}}</span>分</div>
			</div>
			<div class="accuracy">您的正确率是<span>{{scoreData.accuracy || '0'}}</span>%</div>
			<div class="xiazai">下载报告查看详细分析</div>
			<div class="scorebox">
				<div class="item">
					<div class="score">{{scoreData.success || '0'}}</div>
					<div class="">正确</div>
				</div>
				<div class="item">
					<div class="score">{{scoreData.error || '0'}}</div>
					<div class="">错误</div>
				</div>
				<div class="item">
					<div class="score">{{scoreData.avgaccuracy || '0'}}%</div>
					<div class="">群体正确率</div>
				</div>
			</div>
			<div class="download seeanswer" @click="SeeAnswerFun()">点击查看答案与解析</div>
			<div class="download" @click="downloadFun()">点击预览并下载报告</div>
			<div class="continue" @click="reEvaluateFun()">继续测评</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Completed",

		data() {
			return {
				id: '',
				scoreData: '', //展示的数据
			};
		},
		computed: {

		},
		mounted() {
			this.id = this.$route.query.id //报告id

			//展示数据
			if (localStorage.getItem('scoreData')) {
				this.scoreData = JSON.parse(localStorage.getItem('scoreData'))
			}
		},
		beforeDestroy() {
			// localStorage.removeItem('scoreData'); //清除缓存
		},
		methods: {
			//下载报告
			downloadFun() {
				// this.$router.replace({
				// 	name: 'evaluationReport',
				// 	query: {
				// 		id: this.id
				// 	}, //参数
				// })
				const routeData = this.$router.resolve({
					name: 'evaluationReport',
					query: {
						id: this.id
					}, //参数
				});
				window.open(routeData.href, '_blank');
			},
			//继续测评
			reEvaluateFun() {
				this.$router.replace({
					name: 'Index',
				})
			},
			//查看答案和解析
			SeeAnswerFun() {
				localStorage.setItem('isSeeAnswer', true); //设置为true（可查看答案和解析）
				this.$router.push({
					name: 'Answer',
					query: {
						reportID: this.id
					}, //参数
				});
				// const routeData = this.$router.resolve({
				// 	name: 'Answer',
				// 	query: {
				// 		reportID: this.id
				// 	}, //参数
				// });
				// window.open(routeData.href, '_blank');
			},
		},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.index_content {
		text-align: center;
		background: #fff;
		padding-top: 0;
	}

	.complet_title {
		margin-top: 20px;
		width: 100%;
		height: 125px;
		background: url('../../assets/imgs/bg_p06@2x.png') no-repeat;
		background-size: 100% 100%;
		position: relative;
	}

	.complet_con_tit {
		margin: 33px 0;
		font-size: 18px;
		font-weight: 600;
		letter-spacing: 0px;
		color: rgba(0, 0, 0, 1);
	}

	.complet_title .tips {
		position: absolute;
		top: 53px;
		left: 75px;
		font-size: 12px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 17.38px;
		color: rgba(0, 0, 0, 1);
		text-align: left;
	}


	.complet_title .tips .tit_a {
		font-size: 24px;
		font-weight: 700;
		letter-spacing: 0px;
		line-height: 34.75px;
		color: rgba(0, 0, 0, 1);
	}

	.complet_con_circle {
		position: relative;
		width: 150px;
		height: 150px;
		background: url('../../assets/imgs/circle.png') no-repeat;
		background-size: 100% 100%;
		margin: auto;
	}

	.complet_con_circle img {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 125px;
		height: 125px;
	}

	.complet_con_circle .num {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
		font-weight: 500;
		letter-spacing: 0px;
		line-height: 28.96px;
		color: rgba(0, 0, 0, 1);

	}

	.complet_con_circle .num span {
		font-size: 44px;
		font-weight: 700;
		letter-spacing: 0px;
		line-height: 66.61px;
		color: rgba(62, 136, 254, 1);
		margin-right: 4px;
	}



	.accuracy {
		padding-top: 15px;
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 34.75px;
		color: rgba(51, 51, 51, 1);

	}

	.accuracy span {
		font-size: 24px;
	}

	.download {
		width: 315px;
		height: 50px;
		opacity: 1;
		border-radius: 30px;
		background: rgba(78, 142, 255, 1);
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		color: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		margin: auto;
		cursor: pointer;
		margin-top: 15px;
	}

	.seeanswer {
		border: 1px solid rgba(78, 142, 255, 1) !important;
		background-color: #fff;
		color: rgba(78, 142, 255, 1);
		margin-top: 40px;
	}

	.scorebox {
		margin-top: 15px;
		width: 315px;
		height: 80px;
		opacity: 1;
		border-radius: 10px;
		background: rgba(247, 249, 251, 1);
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin: auto;
	}

	.scorebox .item {
		width: 33%;
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 20.27px;
		color: rgba(153, 153, 153, 1);
		position: relative;
	}

	.scorebox .item:first-child,
	.scorebox .item:nth-child(2) {
		cursor: pointer;
	}

	.scorebox .item .score {
		font-size: 20px;
		font-weight: 700;
		letter-spacing: 0px;
		line-height: 28.96px;
		color: rgba(51, 51, 51, 1);
	}

	.scorebox .item:nth-child(2)::before {
		clear: both;
		content: '';
		display: block;
		position: absolute;
		top: 28%;
		left: 0;
		width: 1px;
		height: 20px;
		opacity: 1;
		background: rgba(204, 204, 204, 1);
	}

	.scorebox .item:nth-child(2)::after {
		clear: both;
		content: '';
		display: block;
		position: absolute;
		top: 28%;
		right: 0;
		width: 1px;
		height: 20px;
		opacity: 1;
		background: rgba(204, 204, 204, 1);
	}

	.xiazai {
		font-size: 14px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 20.27px;
		color: rgba(153, 153, 153, 1);
		margin-bottom: 15px;
	}

	.continue {
		/** 文本1 */
		font-size: 12px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 17.38px;
		color: rgba(102, 102, 102, 1);
		text-align: center;
		margin-top: 18px;
		display: none;
	}

	@media screen and (max-width:600px) {

		.complet_title {
			margin-top: 0;
			background: url('../../assets/imgs/bg04@2x.png') no-repeat;
			background-size: contain;
			height: 500px;
		}

		.complet_title .tips {
			top: 40px;
			left: 30px;
		}

		.complet_con {
			position: relative;
			z-index: 99;
			width: 90%;
			margin: auto;
			margin-top: -370px;
			box-sizing: border-box;
			height: auto;
			border-radius: 15px 15px 0px 0px;
			background: rgba(255, 255, 255, 1);
			padding: 20px 15px;
		}

		.complet_con_tit[data-v-70712a39] {
			margin: 0 0 20px;
			text-align: left;
		}

		.continue {
			display: block;
		}

	}
</style>